import type { FC } from 'react';
import { ArraysWrapper } from './Arrays.styled';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';

interface ArraysProps { }

const Arrays: FC<ArraysProps> = () => (
   <ArraysWrapper>
      <header className="entry-header ">
         <h1 className="entry-title" itemProp="headline">Arrays</h1>
      </header>
      <div className="entry-content clear" itemProp="text">
         <ul className="text-align-justify">
            <li>An array is a collection in java with similar types of elements that have a contiguous memory location.</li>
            <li>In addition, special treatment is given to arrays in java as it is treated as an object which contains elements of a similar data type.</li>
            <li>In addition, it is efficient to retrieve or sort the data with arrays and to access elements randomly.</li>
            <li>It can store only a fixed set of elements. Therefore, it doesn’t grow its size at runtime. So we use the collection framework which grows automatically.</li>
            <li>An array can contain primitives (int, char, etc) as well as to object (or non-primitive) elements.</li>
            <li>Java array inherits the Object class and implements the Serializable as well as Cloneable interfaces.</li>
            <li>Arrays in java can be classified as :
               <ul>
                  <li>Single Dimensional Array </li>
                  <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                     {
                        'dataType[] a = {};\n'+
                        'dataType[] a = new dataType[size];\n'+
                        'dataType []a = {};\n'+
                        'dataType []a = new dataType[size];\n'+
                        'dataType a[] = {}\n'+
                        'dataType a[] = new dataType[size];'
                     }
                  </SyntaxHighlighter>
                  <li>Multi Dimensional Array </li>
                  <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                     {
                        'dataType[][] a = { {}, {}, {} };\n'+
                        'dataType[][] a = new dataType[row size][column size];\n'+
                        'dataType [][]a = { {}, {}, {} };\n'+
                        'dataType [][]a = new dataType[row size][column size];\n'+
                        'dataType a[][] = { {}, {}, {} };\n'+
                        'dataType a[][] = new dataType[row size][column size];\n'+
                        'dataType []a[] = { {}, {}, {} };\n'+
                        'dataType []a[] = new dataType[row size][column size];'
                     }
                  </SyntaxHighlighter>
               </ul>
            </li>
            <li>ArrayIndexOutOfBoundsException :
               <ul>
                  <li>JVM throws this exception if we try to access an element outside the array size.</li>
                  <li>In other words, it indicates that an array has been accessed with an illegal index.</li>
                  <li>An illegal index refers to one that is either negative or greater than or equal to the size of an array.</li>
               </ul>
            </li>
         </ul>
      </div>
   </ArraysWrapper>
);

export default Arrays;
